/* GENERADO — no editar aquí.
   Fuente: marca/produccion/marcas.json
   Regenerar: pnpm brand:sync
   ------------------------------------------------------------------------- */

export type Marca = {
  /** Clave estable. Es lo que se guarda en la fila del hábito. */
  readonly id: string;
  /** Nombre en español, para el selector. */
  readonly n: string;
  /** Qué dibuja, para la prueba ciega. */
  readonly c: string;
  /** Trazo. Se pinta con stroke, nunca con fill. */
  readonly d: string;
  /** Parte maciza, si la tiene. Cadena vacía = no hay. */
  readonly f: string;
};

/** Retícula de 24. Trazo 1,8 sobre pieza neutra; 1,4 sobre disco de área. */
export const MARCA_VIEWBOX = '0 0 24 24';

export const MARCAS: readonly Marca[] = [
  {
    "id": "deporte",
    "n": "Deporte",
    "c": "figura corriendo",
    "d": "M15 7.5 L10.5 13 M10.5 13 L5 16 L3 20.5 M10.5 13 L15.5 15.5 L14 20.5 M14.5 9 L9 8 L7.5 5 M14.5 9 L19 11.5 L21.5 9.5",
    "f": "M16 1.8 A2.2 2.2 0 1 1 16 6.2 A2.2 2.2 0 1 1 16 1.8 Z"
  },
  {
    "id": "lectura",
    "n": "Lectura",
    "c": "libro abierto",
    "d": "M12 7 C10 5 6 4.5 3 5.5 V19 C6 18 10 18.5 12 20.5 C14 18.5 18 18 21 19 V5.5 C18 4.5 14 5 12 7 Z M12 7 V20.5",
    "f": ""
  },
  {
    "id": "escritura",
    "n": "Escritura",
    "c": "lápiz",
    "d": "M14.5 4.5 L19.5 9.5 L8.5 20.5 H3.5 V15.5 Z M12.5 6.5 L17.5 11.5",
    "f": ""
  },
  {
    "id": "meditacion",
    "n": "Meditación",
    "c": "loto",
    "d": "M12 4.5 C9.5 7.5 9.5 12.5 12 15.5 C14.5 12.5 14.5 7.5 12 4.5 Z M12 15.5 C9 15 6 12.5 5 9 C8.5 9.5 11 12 12 15.5 M12 15.5 C15 15 18 12.5 19 9 C15.5 9.5 13 12 12 15.5 M3.5 17 C6 19.5 9 20.5 12 20.5 C15 20.5 18 19.5 20.5 17",
    "f": ""
  },
  {
    "id": "sueno",
    "n": "Sueño",
    "c": "luna",
    "d": "M12 3 A6 6 0 0 0 21 12 A9 9 0 1 1 12 3 Z",
    "f": ""
  },
  {
    "id": "agua",
    "n": "Agua",
    "c": "gota (vértice arriba)",
    "d": "M12 3 C12 3 5 10.5 5 15 A7 7 0 0 0 19 15 C19 10.5 12 3 12 3 Z",
    "f": ""
  },
  {
    "id": "comida",
    "n": "Comida",
    "c": "tenedor y cuchillo",
    "d": "M7 3 V21 M4 3 V8 A3 3 0 0 0 10 8 V3 M19 3 C15.5 6 15.5 12 19 13.5 V21",
    "f": ""
  },
  {
    "id": "estudio",
    "n": "Estudio",
    "c": "birrete",
    "d": "M2.5 9.5 L12 4.5 L21.5 9.5 L12 14.5 Z M6.5 11.5 V16.5 C8 19 16 19 17.5 16.5 V11.5 M21.5 9.5 V14.5",
    "f": ""
  },
  {
    "id": "idiomas",
    "n": "Idiomas",
    "c": "dos bocadillos",
    "d": "M3 4.5 H14.5 V12.5 H8 L4.5 15.5 V12.5 H3 Z M17 9.5 H21 V17.5 H19.5 V20.5 L16 17.5 H10 V14",
    "f": ""
  },
  {
    "id": "musica",
    "n": "Música",
    "c": "corchea",
    "d": "M12 18 V4.5 L19 6.5 V10",
    "f": "M6 18 A3 3 0 1 1 12 18 A3 3 0 1 1 6 18 Z"
  },
  {
    "id": "dinero",
    "n": "Dinero",
    "c": "pila de monedas",
    "d": "M4 7 A8 3 0 1 0 20 7 A8 3 0 1 0 4 7 M4 7 V12 A8 3 0 0 0 20 12 V7 M4 12 V17 A8 3 0 0 0 20 17 V12",
    "f": ""
  },
  {
    "id": "casa",
    "n": "Casa",
    "c": "casa",
    "d": "M3 11.5 L12 4 L21 11.5 V20 H3 Z M10 20 V15 H14 V20",
    "f": ""
  },
  {
    "id": "naturaleza",
    "n": "Naturaleza",
    "c": "hoja",
    "d": "M20.5 3.5 C11 3.5 4 10 3.5 20.5 C14 20 20.5 13 20.5 3.5 Z M3.5 20.5 L15 9",
    "f": ""
  },
  {
    "id": "personas",
    "n": "Personas",
    "c": "dos personas",
    "d": "M3 20 V18.5 A6 6 0 0 1 15 18.5 V20 M16.5 12.5 A4.5 4.5 0 0 1 21.5 17 V20",
    "f": "M9 3.5 A2.6 2.6 0 1 1 9 8.7 A2.6 2.6 0 1 1 9 3.5 Z M17 5.5 A2.2 2.2 0 1 1 17 9.9 A2.2 2.2 0 1 1 17 5.5 Z"
  },
  {
    "id": "trabajo",
    "n": "Trabajo",
    "c": "maletín",
    "d": "M3 8 H21 V19 H3 Z M9 8 V5 H15 V8 M3 13 H21",
    "f": ""
  },
  {
    "id": "salud",
    "n": "Salud",
    "c": "corazón",
    "d": "M12 20 C12 20 3 14.5 3 8.5 A4.5 4.5 0 0 1 12 7 A4.5 4.5 0 0 1 21 8.5 C21 14.5 12 20 12 20 Z",
    "f": ""
  },
  {
    "id": "medicacion",
    "n": "Medicación",
    "c": "cápsula",
    "d": "M14.5 4.5 L4.5 14.5 A3.54 3.54 0 0 0 9.5 19.5 L19.5 9.5 A3.54 3.54 0 0 0 14.5 4.5 Z M9.5 9.5 L14.5 14.5",
    "f": ""
  },
  {
    "id": "higiene",
    "n": "Higiene",
    "c": "ducha",
    "d": "M5 11.5 A7 7 0 0 1 19 11.5 Z M12 4.5 V3 H19 V7 M8 15.5 V18 M12 16 V19 M16 15.5 V18",
    "f": ""
  },
  {
    "id": "orden",
    "n": "Orden",
    "c": "percha",
    "d": "M12 6.5 A2 2 0 1 1 14 4.5 M12 6.5 V9 L21 16 H3 L12 9",
    "f": ""
  },
  {
    "id": "creatividad",
    "n": "Creatividad",
    "c": "bombilla",
    "d": "M9 18 H15 M10 21 H14 M9 18 C9 15.5 5 13.5 5 9.5 A7 7 0 0 1 19 9.5 C19 13.5 15 15.5 15 18",
    "f": ""
  },
  {
    "id": "descanso",
    "n": "Descanso",
    "c": "sofá",
    "d": "M3 19 V12 A2 2 0 0 1 7 12 V14.5 H17 V12 A2 2 0 0 1 21 12 V19 Z M7 14.5 V9 A3 3 0 0 1 10 6 H14 A3 3 0 0 1 17 9 V14.5 M5 19 V21 M19 19 V21",
    "f": ""
  },
  {
    "id": "tiempo",
    "n": "Tiempo",
    "c": "reloj de arena",
    "d": "M6 3 H18 M6 21 H18 M7.5 3 C7.5 8 11 9.5 11 12 C11 14.5 7.5 16 7.5 21 M16.5 3 C16.5 8 13 9.5 13 12 C13 14.5 16.5 16 16.5 21",
    "f": ""
  },
  {
    "id": "caminar",
    "n": "Caminar",
    "c": "huellas",
    "d": "M6 8 A2.5 3.5 0 1 1 11 8 A2.5 3.5 0 1 1 6 8 Z M13 12 A2.5 3.5 0 1 1 18 12 A2.5 3.5 0 1 1 13 12 Z",
    "f": "M7 14.8 A1.6 1.6 0 1 1 10.2 14.8 A1.6 1.6 0 1 1 7 14.8 Z M14 18.8 A1.6 1.6 0 1 1 17.2 18.8 A1.6 1.6 0 1 1 14 18.8 Z"
  },
  {
    "id": "fuerza",
    "n": "Fuerza",
    "c": "mancuerna",
    "d": "M2.5 10 V14 M5.5 7.5 V16.5 M18.5 7.5 V16.5 M21.5 10 V14 M5.5 12 H18.5",
    "f": ""
  },
  {
    "id": "pantalla",
    "n": "Pantalla",
    "c": "teléfono",
    "d": "M9 3 H15 A2 2 0 0 1 17 5 V19 A2 2 0 0 1 15 21 H9 A2 2 0 0 1 7 19 V5 A2 2 0 0 1 9 3 Z M10.5 18 H13.5",
    "f": ""
  },
  {
    "id": "respiracion",
    "n": "Respiración",
    "c": "viento",
    "d": "M3 8 H13.5 A2.5 2.5 0 1 0 11 5.5 M3 13 H18.5 A2.5 2.5 0 1 1 16 15.5 M3 18 H11 A2 2 0 0 1 13 20",
    "f": ""
  },
  {
    "id": "cafe",
    "n": "Café",
    "c": "taza",
    "d": "M4 8 H17 V15 A5 5 0 0 1 12 20 H9 A5 5 0 0 1 4 15 Z M17 10 H19 A2.5 2.5 0 0 1 19 15 H17",
    "f": ""
  },
  {
    "id": "diario",
    "n": "Diario",
    "c": "cuaderno",
    "d": "M5 3 H19 V21 H5 Z M8.5 3 V21 M12 8 H15.5 M12 12 H15.5",
    "f": ""
  }
];

export const MARCAS_BY_ID: ReadonlyMap<string, Marca> = new Map(
  MARCAS.map((m) => [m.id, m]),
);
